import './Spinner-2dbceeca.css';

var classes = {"Box":"prc-Spinner-Box-qNUI9","SpinnerAnimation":"prc-Spinner-SpinnerAnimation-e7Gf-"};

export { classes as default };
